var module = angular.module('octopusApp.shared');

module.directive('helpBlock', function (helpManager) {
  return {
    restrict: 'C',
    link: function(scope, element, attrs) {

    }
  };
});






//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/help_block.js
// module id = 591
// module chunks = 1